/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

const NavBar = ({profitAndLoss, searchParams, pageType, setPageType, isLoading})=>{ 
    const navigate = useNavigate()
    const searchParamsCopy = new URLSearchParams(searchParams);
    const upperCaseSegments = ['p%20&%20l']; // Add more segments as needed
    const capitalSegments = ['income', 'expenses']; // Correctly split the segments
    const [truncateLength, setTruncateLength] = useState(15);

    // Split the pathname into segments
    const [segments, setSegments] = useState(location.pathname.split('/').slice(3))

    // Helper function to generate the path for each segment
    const generatePath = (index, searchParamsForGenerate) => `/financial-statements/profit-and-loss-sheet/${segments.slice(0, index + 1).join('/')}${searchParamsForGenerate.toString() === '' ? '' : `?${searchParamsForGenerate.toString()}`}`;

    // Helper function to get the category details based on the current path
    const getCategoryDetails = (pathSegments) => {
        let categoryDetails = profitAndLoss;
        pathSegments.forEach(segment => {
            if (categoryDetails && categoryDetails.hasOwnProperty(segment)) {
                categoryDetails = categoryDetails[segment];
            }
        });
        return categoryDetails;
    };

    // Get the current category details
    const currentCategory = getCategoryDetails(segments);

    // Helper function to truncate a string if it exceeds a certain length
    const truncateString = (str, num) => {
        if (str.length <= num) {
            return str;
        }
        return str.slice(0, num) + '...';
    };

    // Effect to update truncate length based on screen size
    useEffect(() => {
        const updateTruncateLength = () => {
            if (window.innerWidth < 1536) {
                setTruncateLength(7);//set the number at which it needs to truncated in small screen
            } else {
                setTruncateLength(18);//set the number at which it needs to truncated in big screen
            }
        };

        window.addEventListener('resize', updateTruncateLength);
        updateTruncateLength(); // Initial check

        return () => {
            window.removeEventListener('resize', updateTruncateLength);
        };
    }, []);

    // Effect to update segments based on location.pathname
    useEffect(() => {
        setSegments(location.pathname.split('/').slice(3));
    }, [location.pathname]);
    
    // Effect to re-render when searchParams changes
    useEffect(() => {
        // This empty effect re-renders the component when searchParams changes
    }, [searchParams]);

    //navigates to clicked path
    const navItemHandler = async (index) => {
        if (isLoading) return;
        let path = generatePath(index, searchParamsCopy);   
        if (location.pathname === path.split('?')[0]) {
            return;
        } else {
            const searchParamsCopy = new URLSearchParams(searchParams);
            if (index >= 2) {
                if((index === 2)){
                    searchParamsCopy.set('type', 'mainGroup');
                    setPageType('mainGroup');
                } else {
                    searchParamsCopy.set('type', 'drill_down');
                    setPageType('drill_down');
                }                
                // Determine parameters to remove based on the index
                if(index === 2){
                    searchParamsCopy.delete('ledger_id');
                    searchParamsCopy.delete('ay_id');
                    searchParamsCopy.delete('class_id');
                    searchParamsCopy.delete('section_id');
                    searchParamsCopy.delete('student_id');
                    searchParamsCopy.delete('student_uuid');
                    searchParamsCopy.delete('page_number');
                    searchParamsCopy.delete('grand_total');
                }
                if (index === 3) {
                    searchParamsCopy.delete('ay_id');
                    searchParamsCopy.delete('class_id');
                    searchParamsCopy.delete('section_id');
                    searchParamsCopy.delete('student_id');
                    searchParamsCopy.delete('student_uuid');
                    searchParamsCopy.delete('page_number');
                    searchParamsCopy.delete('grand_total');
                } 
                if (index === 4) {
                    searchParamsCopy.delete('class_id');
                    searchParamsCopy.delete('section_id');
                    searchParamsCopy.delete('student_id');
                    searchParamsCopy.delete('page_number');
                    searchParamsCopy.delete('grand_total');
                }
                if (index === 5) {
                    searchParamsCopy.delete('section_id');
                    searchParamsCopy.delete('student_id');
                    searchParamsCopy.delete('student_uuid');
                    searchParamsCopy.delete('page_number');
                    searchParamsCopy.delete('grand_total');
                }
                if (index === 6){
                    searchParamsCopy.delete('student_id');
                    searchParamsCopy.delete('student_uuid');
                    searchParamsCopy.delete('page_number');
                    searchParamsCopy.delete('grand_total');
                }
    
                path = generatePath(index, searchParamsCopy);            
                navigate(path);
            } else {
                // Remove params.type before adding search parameters
                searchParamsCopy.delete('ledger_id');
                searchParamsCopy.delete('ay_id');
                searchParamsCopy.delete('class_id');
                searchParamsCopy.delete('section_id');
                searchParamsCopy.delete('student_id');
                searchParamsCopy.delete('student_uuid');
                searchParamsCopy.delete('page_number');
                searchParamsCopy.delete('page_number_sub_inventory');
                searchParamsCopy.delete('inv_id');
                searchParamsCopy.delete('grand_total');
                searchParamsCopy.set('type', 'main');
                setPageType('main')
                navigate(`/financial-statements/profit-and-loss-sheet${searchParamsCopy.toString() === '' ? '' : `?${searchParamsCopy.toString()}`}`);
            }
        }
    };
    

    return(
        <div className='flex flex-wrap pb-[10px] font-semibold pt-[32px]' id={'nav_bar_hirerachy'}>
            {segments?.map((segment, index) => (
                <div key={index + segment} className={`flex ${index==segments?.length-1 && index >6 ?"last-item":""}`}>
                    {(index !== 0) && <span>&nbsp;&#62;&nbsp;</span>}
                    <div 
                        className={
                            index === segments?.length - 1 
                                ? (capitalSegments.includes(segment.toLowerCase()) ? 'text-[#106EB4] px-[2px] capitalize' : 'text-[#106EB4] px-[2px]')
                                : 'cursor-pointer px-[2px]'
                        }
                        onClick={() => navItemHandler(index)}
                        title={upperCaseSegments.includes(segment.toLowerCase())
                            ? decodeURIComponent(segment.toUpperCase())
                            : capitalSegments.includes(segment.toLowerCase())
                                ? decodeURIComponent(segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase())
                                : decodeURIComponent(segment)}
                    >
                        {truncateString(
                            upperCaseSegments.includes(segment.toLowerCase())
                                ? decodeURIComponent(segment.toUpperCase())
                                : capitalSegments.includes(segment.toLowerCase())
                                    ? decodeURIComponent(segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase())
                                    : decodeURIComponent(segment),
                            (index === segments?.length - 1 ? segment.length : truncateLength)
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default NavBar;